export const formatDate = (date, locale) =>
  `${new Date(date).toLocaleString(`${locale}-CA`, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })}`
